import type {ReactAction} from '@netx/core/bootstrap';
import {faShare} from '@netx/core-icons';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import type {SavedSearch} from '../types';
import {searchSavedActionShareLink} from './search-saved-share-link';
import {searchSavedActionTeamAccess} from './search-saved-share-team-access';

export const searchSavedActionShareMenuIcon = faShare;

/**
 * Share saved search
 * @param params
 * @returns Action
 */
export const searchSavedActionShareMenu = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-share-menu',
	cb: () => {},
	icon: searchSavedActionShareMenuIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.MENU;
	},
	children: [
		searchSavedActionShareLink(savedSearch),
		searchSavedActionTeamAccess(savedSearch),
	],
	...params,
});

export default searchSavedActionShareMenu;
